import { EventRequest, Lot, LotChanges, QualQuestion, ZeroStartingPrice } from 'types';

/**
 * Updates the request properties with the new lots, survey questions, changes, and zero starting prices.
 * Only updates if the request object is defined and has a setRequestProperty function.
 *
 * @param {EventRequest | undefined} request - The event request object that may contain setRequestProperty function
 * @param {Lot[]} newAllLots - All lots including the newly imported ones
 * @param {QualQuestion[]} newAllSurveyQuestions - All survey questions including newly generated ones
 * @param {Record<string, LotChanges>} changes - The changes record with updates for imported lots
 * @param {any} zeroStartingPrices - Zero starting prices calculated from the lots
 * @returns {void} This function doesn't return a value
 */
export const updateRequestPropertiesOnImport = (
  request: EventRequest | undefined,
  newAllLots: Lot[],
  newAllSurveyQuestions: QualQuestion[],
  changes: Record<string, LotChanges>,
  zeroStartingPrices: ZeroStartingPrice[]
): void => {
  if (request && typeof request.setRequestProperty === 'function') {
    request.setRequestProperty({
      all_survey_questions: newAllSurveyQuestions,
      lots: newAllLots,
      lotsChanges: changes,
      zeroStartingPrices
    });
  }
};
